import { ChevronLeft, ChevronRight } from 'lucide-react'

interface EmpresasPaginationProps {
  totalCount: number
  page: number
  totalPages: number
  pageSize: number
  onPageChange: (page: number) => void
}

export function EmpresasPagination({
  totalCount,
  page,
  totalPages,
  pageSize,
  onPageChange,
}: EmpresasPaginationProps) {
  if (totalCount <= pageSize) return null

  return (
    <div className='flex items-center justify-between mt-4 px-2'>
      <p className='text-xs text-text-muted'>
        {totalCount} registro{totalCount !== 1 ? 's' : ''} · Página {page} de {totalPages}
      </p>
      <div className='flex items-center gap-1'>
        <button
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className='p-2 rounded-md text-text-muted hover:text-text-primary hover:bg-white/[0.06] transition-all disabled:opacity-30 disabled:cursor-not-allowed'
        >
          <ChevronLeft size={16} />
        </button>
        {Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
          let pageNum: number
          if (totalPages <= 7) {
            pageNum = i + 1
          } else if (page <= 4) {
            pageNum = i + 1
          } else if (page >= totalPages - 3) {
            pageNum = totalPages - 6 + i
          } else {
            pageNum = page - 3 + i
          }
          return (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`min-w-[36px] h-9 rounded-md text-xs font-medium transition-all ${
                page === pageNum
                  ? 'bg-accent text-white'
                  : 'text-text-muted hover:text-text-primary hover:bg-white/[0.06]'
              }`}
            >
              {pageNum}
            </button>
          )
        })}
        <button
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          className='p-2 rounded-md text-text-muted hover:text-text-primary hover:bg-white/[0.06] transition-all disabled:opacity-30 disabled:cursor-not-allowed'
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  )
}
